/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosports2ColumnImagesViewProps } from './hosports-2-column-images';

export default (props: IHosports2ColumnImagesViewProps) => {
    return (
        <h2>{'hosports-two-column-images-view'}</h2>
    );
};
